import(/* webpackMode: "eager" */ "/home/nodejs/apps/ecgbox/frontend/src/app/page.tsx")